export enum ModalType {
  PREPARING = 'preparing',
  DOWNLOADING = 'downloading',
}
